import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  Tarea,
  DynamicComponentForm,
  Context,
  TaskEvent,
  ConfigFinishDefault,
  ConfirmComponent,
  Const,
  BaseControl,
  DocumentoInventario,
  Static,
} from '@app/shared';
import { DocumentInventoryFormConfig } from './shared/document-inventory-form.config.service';
import { DocumentInventoryFormService } from './shared/document-inventory-form.form.service';
import { DocumentInventoryFormDataService } from './shared/document-inventory-form.data.service';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { find } from 'lodash';



@Component({
  selector: 'iw-document-inventory-form',
  templateUrl: './document-inventory-form.component.html',
  styleUrls: ['./document-inventory-form.component.scss'],
  providers: [
    DocumentInventoryFormService,
    DocumentInventoryFormDataService
  ]
})
export class DocumentInventoryFormComponent extends DynamicComponentForm implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // contiene la configuracion de la tabla
  settings = {};
  // informacion de datos a mostrar en la tabla
  source: Array<any> = [];
  // Contiene los controles de el formulario de pubblicaciones
  controls: BaseControl<any>[] = [];
  // Referencia del formulario
  form: FormGroup;
  // Contiene el formulario en el cual se registra la fecha para realizar el inventario documental
  formData: FormData = new FormData();
  //modal
  modalRef: BsModalRef;
  // Referencia al componente de confirmación modal
  @ViewChild("confirm") private confirm: ConfirmComponent;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  //Referencia al modal personalizado
  @ViewChild("modalExp") modalExp: any;
  // Contiene los rows seleccionados  
  selectedRows: any;
  // contiene el año ingresado
  year: number;
  // Pregunta de la modal de confirmaciones
  question = "";

  settingsModal = {};
  sourceModal: Array<any> = [];
  selectedModalrow: any;
  // documentos seleccionados
  documents: number[] = [];
  // bloquea el formulario de periodo de  inventario
  disbaleForm:boolean = false;

  constructor(
    private toastr: ToastrService, 
    private dis: DocumentInventoryFormService,
    private ddis: DocumentInventoryFormDataService,
    private modal: BsModalService,
    ) {
    super();
  }

  async ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }

    let infoInventory = await this.ddis.getDocumentInventoryInfo({"tarea_id":this.task.id,"tipo":"periodo_inventario"});
    if (infoInventory){
      this.year = infoInventory['year'];
    }
    this.controls = this.dis.getFormDocumentInventory(this.year);
    const configTable = new DocumentInventoryFormConfig();
    this.settings = configTable.settings;
    this.settingsModal = configTable.settingsModal;
    configTable.accion.subscribe((res: any) => {
        this.download(res);
      });
    if(this.year){
      let dataSend = {
        "year": Number(this.year),
        "tarea_id": this.task.id,
        "tipo": "inventario_documental"
    };
    this.source = await this.ddis.getDocumentInventory(dataSend);
    await Static.asyncForEach(this.source, async (registry: DocumentoInventario) => {
      if(registry.expediente){
        this.disbaleForm = true;
        this.form.disable();
      }
    });
    }
    if(this.finishTask){
      this.form.disable();
    }
    
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof DocumentInventoryFormComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof DocumentInventoryFormComponent
   */
  finishConfirm() {
    if (this.userResponsible && !this.finishTask && !this.secondaryActive) {
      if(this.disbaleForm){
        this.confirmFinish.open();
      }else{
        this.toastr.warning(
          'No se puede realizar esta acción debido a que no sean asociado documentos a expedientes',
          'Acción no permitida'
        );
      }
      
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

   /**
   * Valida el documento y emite la acción de descargar
   *
   * @private
   * @param {number} data
   * @returns {*}
   * @memberof DocumentInventoryFormComponent
   */
    private download(data: number): any {
        this.ddis.dowloadFile(data).subscribe((res: any) => {
          const a = document.createElement('a');
          a.target = '_blank';
          a.href = res.file.path;
          a.download = res.file.name;
          a.click();
          a.remove();
        });
      }

     /**
   * contiene los rows seleccionados
   *
   * @param {*} event
   * @memberof DocumentInventoryFormComponent
   */
  onRowSelect(event: any) {
    this.selectedRows = event.selected;
  }

    /**
   * Metodo que organiza el formData y modifica una publicacion
   *
   * @memberof DocumentInventoryFormComponent
   */
  async sended() {
        if (this.form.valid) {
          let parameters = {
            "year": Number(this.form.controls['fecha_inventario'].value),
            "tarea_id": this.task.id,
            "tipo": "registrar_periodo_inventario"
          }
          let result = await this.ddis.sendDocumentsInfo(parameters)
          if (result){
            this.year = this.form.controls['fecha_inventario'].value;
            let dataSend = {
                "year": Number(this.year),
                "tarea_id": this.task.id,
                "tipo": "inventario_documental"
            };
            this.source = await this.ddis.getDocumentInventory(dataSend);
          }
        }
      }

     /**
   * Metodo que realiza la asociacion masiva
   *
   * @return {*}
   * @memberof DocumentInventoryFormComponent
   */
  async associateExp() {
    this.documents.length = 0;
    if (this.selectedRows){
        this.selectedRows.forEach((d: DocumentoInventario) => {
            if (!d.expediente) {
              this.documents.push(d.id);
            }
          });
        if(this.documents.length){
          let dataSend = {
            "year": Number(this.year),
            "tarea_id": this.task.id,
            "tipo": "inventario_documental_expedientes"
        };
          this.sourceModal.length = 0;
          this.sourceModal = await this.ddis.getDocumentInventoryExp(dataSend);
          this.modalRef = this.modal.show(this.modalExp, {
              class: "modal-lg-personalized",
              ignoreBackdropClick: true,
        });
        }else{
          this.toastr.warning("Debe seleccionar documentos que no esten asociados con un expediente", 'Advertencia');
        }
          
    } 
  }

  /**
   *Cierra la modal
   *
   * @memberof DocumentInventoryFormComponent
   */
   closeModal(){
    this.selectedModalrow = null;
    this.modalRef.hide();
  }

  /**
   * contiene los rows seleccionados dentro del modal
   *
   * @param {*} event
   * @memberof DocumentInventoryFormComponent
   */
   async onRowModalSelect(event: any) {
    this.selectedModalrow = null;
    this.selectedModalrow = await event.selected;
  }

  /**
   * contiene los rows seleccionados dentro del modal
   *
   * @param {*} event
   * @memberof DocumentInventoryFormComponent
   */
   associateExpSelection() {
     if (this.selectedModalrow != null && this.selectedModalrow.length){
      this.question = "¿Realmente desea asociar los documentos al expediente: "+this.selectedModalrow[0].numero+" ?";
      this.confirm.open();
     }
  }

 /**
   * respuesta dada desde el modal de confirmacion
   *
   * @param {*} res
   * @memberof DocumentInventoryFormComponent
   */
  async actionComfirm(res: boolean) {
    if (res) {
      if (this.selectedModalrow) {
        let dataSend = {
          "year": Number(this.year),
          "tarea_id": this.task.id,
          "id_documentos": this.documents,
          "id_expediente": this.selectedModalrow[0].id,
          "tipo": "asociar_documento"
        };
        let result = await this.ddis.sendDocumentsInfo(dataSend);
        if(result){
          this.selectedModalrow = null;
          let dataSend = {
            "year": Number(this.year),
            "tarea_id": this.task.id,
            "tipo": "inventario_documental"
          };
          this.source = await this.ddis.getDocumentInventory(dataSend);
          this.closeModal();
          this.documents.length = 0;
          await Static.asyncForEach(this.source, async (registry: DocumentoInventario) => {
              if(registry.expediente){
                this.disbaleForm = true;
                this.form.disable();
              }
            });

        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/all/document-inventory-form/document-inventory-form.component.ts